import { IAppState } from '../../redux';
import { IFormattedBetLeader } from '../../redux/reducers';
import { formatMoney } from '../../utils/string';

/** Максимальное количество компаний, которое умещается в строку */
export const MAX_COMPANIES_COUNT = 6;

export function selectFormattedBetLeaders(state: IAppState): IFormattedBetLeader[] {
  const {
    topBets: { leaders },
  } = state;

  return leaders.map(({ bet, auctionPlace, companies }) => {
    const firstCompanies = companies.slice(0, MAX_COMPANIES_COUNT);
    const otherCompanies = companies.slice(MAX_COMPANIES_COUNT);

    return {
      bet: formatMoney(bet),
      auctionPlace,
      companies: firstCompanies,
      otherCompanies,
    };
  });
}
